import { render, staticRenderFns } from "./CardCost.vue?vue&type=template&id=6fa0ca75&"
import script from "./CardCost.vue?vue&type=script&lang=ts&"
export * from "./CardCost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports